module.exports = "<span class=\"wrapper\">\r\n\r\n    <label data-material=\"All Categories\" class=\"js-category all-categories-link top clearfix\">\r\n       <input type=\"checkbox\">\r\n           <span>Search All Categories</span>\r\n    </label>\r\n    </span>\r\n    <span class=\"disabled-message\">\r\n        No categories are available for your current results set\r\n    </span>\r\n    <hr>\r\n\r\n    <div class=\"category-list-region clearfix\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/category-filter-panel.html
// module id = 405
// module chunks = 1